import React from "react";
import { Box } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  label: {
    color: theme.palette.primary.dark,
  },
}));

const LabeledReadOnly = ({ label, children }) => {
  const classes = useStyles();

  return (
    <Box>
      <Typography
        variant="h3"
        component="div"
        gutterBottom
        classes={{ root: classes.label }}
      >
        {label}
      </Typography>
      {children}
    </Box>
  );
};

export default LabeledReadOnly;
